module.exports = function transformFormBlockData(entity, formsConfig) {
	let form_id = entity.id;
	const form_config = formsConfig ? formsConfig.find((f) => f.form_id === form_id) : null;
	if (!form_config) return {};
	return {
		type: entity.type,
		id: entity.id,
		...form_config,
	};
};
